import { MasonryEngineActionHandler } from '@leagueplatform/masonry-engine';
import {
  MasonryDriverAction,
  MasonrySetFormStatusBannerAction,
} from '@leagueplatform/masonry-renderers';

export const SetFormStatusBannerActionHandler: MasonryEngineActionHandler<
  MasonrySetFormStatusBannerAction,
  MasonryDriverAction
> = (action, { stateController }) => {
  const { formNodeId, statusMessage, statusType } = action.payload;
  stateController.setNodeState(formNodeId, (state) => ({
    ...state,
    statusMessage,
    statusType,
  }));
};
